import { TStrapiV4ColorComponent } from '../common-types'
import tailwindColors from '@ind-money/tailwind/tokens/colors'

export function getColorHexFromDotBrandColorNotation(colorPath: string) {
  const keys = colorPath.split('.')
  let result = tailwindColors.brand
  for (const key of keys) {
    if (result[key] === undefined) {
      return undefined
    }

    result = result[key]
  }

  if (typeof result === 'string') {
    return result
  }

  return undefined
}

export function getColorWithFallback(
  color?: TStrapiV4ColorComponent | null,
  fallbackColor?: string,
) {
  return color?.color
    ? getColorHexFromDotBrandColorNotation(color.color)
    : color?.custom_color
      ? color.custom_color
      : fallbackColor
}

function createColorMap(colors: typeof tailwindColors.brand, prefix = '') {
  const colorMap: { [key: string]: string } = {}

  // eslint-disable-next-line guard-for-in
  for (const key in colors) {
    const value = colors[key]

    const newKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      colorMap[newKey] = value
    } else {
      Object.assign(colorMap, createColorMap(value, newKey))
    }
  }

  return colorMap
}

export const colorStringInStrapiToColorMap = createColorMap(
  tailwindColors.brand,
)
